import React from 'react';
import Row from './Row';

const Body = ({ items }) => {
  return (
    <tbody>
      {items.map((order, i) => {
        let bgRow = i % 2 ? 'bg-gray-50' : 'bg-white';
        return (
          <Row
            key={order.ticketId}
            ticketId={order.ticketId}
            name={order.name}
            submittedDate={order.submittedDate}
            status={order.status}
            lastUpdate={order.lastUpdate}
            type={order.type}
            priority={order.priority}
            bgRow={bgRow}
          />
        );
      })}
    </tbody>
  );
};

export default Body;
